<template>
  <a-card :bordered="false">
    <div>
      <a-spin :spinning="loading">
        <a-form :form="form" :layout="formLayout">
          <a-row>
            <a-col :span="12" v-if="false">
              <a-form-item label="系统合同号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['system_contract_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="系统合同号"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合同协议号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['contract_protocol_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="合同协议号"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="境外发货人" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['shipper', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="境外发货人"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="境内收货人" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['recipient', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="境内收货人"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="消费使用单位" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['consumer_use_location', {rules: [{required: true, message: '必填项，请填写信息'}, {max:200, message: '输入超出长度限制'}]}]" placeholder="消费使用单位"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="进口申报日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-date-picker
                  style="width: 100%"
                  v-decorator="['declaration_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                  show-time
                  format="YYYY-MM-DD"
                  placeholder="申报日期"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="进境关别" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['customs_entry', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="进境关别"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="监管方式" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['supervision_mode', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="监管方式"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="货物存放地点" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['storage_location', {rules: [{required: true, message: '必填项，请填写信息'}, {max:200, message: '输入超出长度限制'}]}]" placeholder="货物存放地点"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="启运国（地区）" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['origin_country', {rules: [{required: true, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="启运国（地区）"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="货物名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['product_name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:200, message: '输入超出长度限制'}]}]" placeholder="货物名称"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="商品编码" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['product_code', {rules: [{required: true, message: '必填项，请填写信息'}, {max:50, message: '输入超出长度限制'}]}]" placeholder="商品编码"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="单位" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-select
                  style="width: 100%"
                  placeholder="选择"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  :not-found-content="null"
                  :default-active-first-option="false"
                  v-decorator="['unit', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.unit" :label="val">
                    {{ val }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="毛重" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number allow-clear v-decorator="['gross_weight', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="毛重"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="件数" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number allow-clear v-decorator="['quantity', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="件数"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number allow-clear v-decorator="['count', {initialValue: 1, rules: [{required: true, message: '必填项，请填写信息'}]}]">
                </a-input-number>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="单价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number allow-clear v-decorator="['unit_price', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="单价"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="总价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number allow-clear v-decorator="['total_price', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="总价"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-select
                  v-decorator="[
                    'currency',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="原产国" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['country_of_origin', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="原产国"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="报关单号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['customs_declaration_number', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="报关单号"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="征免" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['levy_exemption_type', {rules: [{required: false, message: '必填项，请填写信息'}, {max:100, message: '输入超出长度限制'}]}]" placeholder="征免"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="备注" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-textarea :autosize="{minRows:1,maxRows:4}" v-decorator="['remark', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <component
          :ref="currentComponent"
          @cancel="handleAddCancel"
          @ok="handleOk"
          :record="mdl"
          :is="currentComponent"
          :visible="visibleFrom"
          v-if="visibleFrom"
          :loading="confirmLoadingFrom"
          :model="mdl"></component>
        <a-row>
          <a-col span="6" :offset="8">
            <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
          </a-col>
          <a-col span="10">
            <a-button @click="handleGoBack">返回</a-button>
          </a-col>
        </a-row>
      </a-spin>
    </div>
  </a-card>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import { project_client_list } from '@/api/trade_project_client'
import { customs_declaration_in_list, customs_declaration_in_update } from '@/api/trade_customs_declaration'

const fields = ['id', 'system_contract_number', 'contract_protocol_number', 'shipper', 'recipient', 'consumer_use_location',
  'declaration_date', 'customs_entry', 'supervision_mode', 'storage_location', 'origin_country', 'gross_weight', 'quantity',
  'product_name', 'product_code', 'count', 'unit', 'total_price', 'unit_price', 'currency',
  'country_of_origin', 'customs_declaration_number', 'levy_exemption_type', 'remark']
export default {
  name: 'TableEdit',
  components: {
  },
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.clientSearch = debounce(this.handleClientSearch, 800)
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      futures_contract_first_id: 0,
      data: {},
      formLayout: 'horizontal',
      mdl: {},
      currentComponent: '',
      loading: false,
      visibleFrom: false,
      confirmLoadingFrom: false
    }
  },
  mounted () {
    customs_declaration_in_list({ id: this.$route.params.id })
      .then(res => {
        console.log(res.data, '我是数据列表@')
        const list = res.data.entries
        if (list && list.length > 0) {
          this.data = list[0]
          this.id = this.data.id
          this.loadEditInfo(this.data)
        }
      })
    this.handleClientSearch(undefined)
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    }
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    handleClientSearch (value) {
      project_client_list({ name: value, project_id: this.$route.query.project_id }).then((res) => {
        const result = res.data.entries || []
        this.clientList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleClientChange (value) {
      if (value === undefined) {
        this.handleClientSearch(value)
      }
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleAddAttachment () {
      this.currentComponent = 'AttachmentCreateForm'
      this.visibleFrom = true
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          customs_declaration_in_update(values, this.id)
            .then((res) => {
              if (res.code === 1000) {
                this.handleGoBack()
                console.log(res, '修改成功')
              }
            })
        }
      })
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 10)
      }).then(() => {
        console.log('loadEditInfo', data)
        const formData = pick(data, fields)
        console.log('loadEditInfo', formData)
        form.setFieldsValue(formData)
      })
    },
    unitPriceValues (values, data) {
      const data_new = data
      // 单价
      if (values) {
        if (values['unit_price_type'] === '2') {
          const turning_month_list = []
          const start_date = values['pricing_period'][0].format('YYYY-MM-DD')
          const end_date = values['pricing_period'][1].format('YYYY-MM-DD')
          const futures_contract = values['futures_contract']
          const lock_up_date = values['lock_up_date']
          turning_month_list.push({
            futures_contract: futures_contract,
            lock_up_date: lock_up_date,
            pricing_period_start_date: start_date,
            pricing_period_end_date: end_date,
            id: this.futures_contract_first_id
          })
          values['futures_contract'] = undefined
          values['lock_up_date'] = undefined
          values['pricing_period'] = undefined
          if (data_new.turning_month_list.length > 0) {
            const data_list = data_new.turning_month_list.map(item => {
              // const start_date = item['pricing_period']['start_date']
              // const end_date = item['pricing_period']['end_date']
              // item['pricing_period_start_date'] = start_date
              // item['pricing_period_end_date'] = end_date
              // item['pricing_period'] = undefined
              item['key'] = undefined
              return item
            })
            turning_month_list.push(...data_list)
          }
          const ids = []
          const turning_month_list_new = []
          for (let i = 0; i < turning_month_list.length; i++) {
            if (turning_month_list[i]['id'] !== undefined) {
              if (!(turning_month_list[i]['id'] in ids)) {
                ids.push(turning_month_list[i]['id'])
                turning_month_list_new.push(turning_month_list[i])
              }
            } else {
              turning_month_list_new.push(turning_month_list[i])
            }
          }
          data_new.turning_month_list = turning_month_list_new
          console.log(data_new)
          // values['turning_month_list'] = turning_month_list
        } else if (values['unit_price_type'] === '3') {
          if (values['price_reference_period']) {
            const start_date = values['price_reference_period'][0].format('YYYY-MM-DD')
            const end_date = values['price_reference_period'][1].format('YYYY-MM-DD')
            values['price_reference_period'] = undefined
            values['price_reference_period_start_date'] = start_date
            values['price_reference_period_end_date'] = end_date
          }
        }
      }
      return {
        values_new: values,
        data_new: data_new
      }
    },
    randomNumber () {
      const current_date = new Date()
      const random = Math.floor(Math.random() * 100000)
      return current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds() + '' + random
    },
    handleAddCancel () {
      this.visibleFrom = false
      this.mdl = {}
      const form = this.$refs[this.currentComponent].form
      form.resetFields() // 清理表单数据（可不做）
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    },
    addTurningMonth (v) {
      console.log(v)
      if (!v) {
        this.turningMonthList = []
      }
      this.currentComponent = 'TurningMonthForm'
      this.mdl['size'] = this.turningMonthList.length
      this.visibleFrom = v
    },
    onDeleteItem (key) {
      const dataSource = [...this.turningMonthList]
      this.turningMonthList = dataSource.filter(item => item.key !== key)
      if (this.turningMonthList.length === 0) {
        this.form.setFieldsValue({ is_turning_month: false })
      }
    },
    handleOk (data) {
      const form = this.$refs[this.currentComponent].form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          // 新增
          if (this.currentComponent === 'KeyPointCreateForm') {
            values.keys = this.randomNumber()
            this.otherData.key_point.push(values)
          } else if (this.currentComponent === 'AttachmentCreateForm') {
            values.url = values.url.fileList[0].url
            values.key = this.randomNumber()
            this.otherData.attachment.push(values)
          } else if (this.currentComponent === 'TurningMonthForm') {
            const start_date = values['pricing_period'][0].format('YYYY-MM-DD')
            const end_date = values['pricing_period'][1].format('YYYY-MM-DD')
            values['pricing_period'] = undefined
            values['pricing_period_start_date'] = start_date
            values['pricing_period_end_date'] = end_date
            values.key = this.randomNumber()
            this.turningMonthList.push(values)
            form.resetFields()
            console.log('转月数据列表：', this.turningMonthList)
            this.otherData.turning_month_list = this.turningMonthList
          }
          this.visibleFrom = false
          form.resetFields()
        } else {
          this.confirmLoading = false
        }
      })
    },
    time (dates, dateStrings) {
      console.log(dateStrings, '时间')
      // this.param.start_date = dateStrings[0]
      // this.param.end_date = dateStrings[1]
    }
  }
}
</script>
<style scoped>
.hidden_item {
  border: 1px solid #eeeeee;
  background-color: #efefef6a;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
</style>
